import React from "react";
import { Star } from "lucide-react";

const items = [
  {
    quote: "AIBoxHub feels less like a vendor and more like an in-house team. The queue intelligence alone paid for itself in 90 days.",
    name: "Dr. Karim Al-Hashimi",
    role: "Chief Medical Officer, Aurelius Health",
    avatar: "https://images.unsplash.com/photo-1766022411633-e88e3650538b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MTk1MTg2Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote: "Polished, fast, and beautifully designed. Our clients notice — and they keep coming back.",
    name: "Sasha Lévigne",
    role: "Founder, Maison Royale Salons",
    avatar: "https://images.unsplash.com/photo-1769636929231-3cd7f853d038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MTk1MTg2Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote: "The AI Marketplace gave our team Claude, GPT and Gemini in one place. We replaced four tools overnight.",
    name: "Mateo Ferraro",
    role: "Head of Operations, OrionPay",
    avatar: "https://images.pexels.com/photos/31869537/pexels-photo-31869537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="section" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="eyebrow mb-4">Testimonials</div>
          <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight leading-[1.05]">
            Loved by <span className="gold-text italic">premium operators</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <div key={i} className="glass-card p-8 flex flex-col" data-testid={`testimonial-${i}`}>
              <div className="flex gap-1 text-gold-400">
                {Array.from({ length: 5 }).map((_, k) => <Star key={k} className="h-4 w-4 fill-gold-400" />)}
              </div>
              <p className="mt-5 font-serif text-lg md:text-xl text-white/90 leading-snug flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="h-10 w-10 rounded-full object-cover border border-white/10" loading="lazy" />
                <div>
                  <div className="text-sm font-medium text-white">{t.name}</div>
                  <div className="text-xs text-white/50">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
